import { getOr, lowerCase } from 'lodash/fp';

const booleanMapValues = { true: true, false: false };

export const parseStringBool = (value: any) => getOr(false, lowerCase(value), booleanMapValues);
